import React from 'react';
import { Router, Redirect } from '@reach/router';

export default () => (
  <Router>
    <Redirect from="/" to="/inventories/" noThrow />
  </Router>
);
